import { render, staticRenderFns } from "./HighlightLabelMakerStats.vue?vue&type=template&id=4f83216d&scoped=true&"
import script from "./HighlightLabelMakerStats.vue?vue&type=script&lang=js&"
export * from "./HighlightLabelMakerStats.vue?vue&type=script&lang=js&"
import style0 from "./HighlightLabelMakerStats.vue?vue&type=style&index=0&id=4f83216d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83216d",
  null
  
)

export default component.exports